<template>
  <div id="app" class="h-100">
    <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
@import url('https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css');
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

html, body, .container-table {
  height: 100%;
}

#app {
  background: #141414;
  width: 100%;
  height: 100%;
}

.page {
  position: fixed;
  width: inherit;
  background-color: transparent !important;
}

.container-table {
    display: table;
}

.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}

.box-neon {
    box-shadow: 
      0 0 5px rgba(0,178,255,1),
      0 0 10px rgba(0,178,255,1),
      0 0 15px rgba(0,178,255,1),
      0 0 20px rgba(38,104,127,1),
      0 0 25px rgba(38,104,127,1),
      0 0 30px rgba(38,104,127,1),
      0 0 35px rgba(38,104,127,1),
      0 0 40px rgba(38,104,127,1),
      0 0 45px rgba(38,104,127,1);
}

.text-neon {
    text-shadow: 
      0 0 5px rgba(0,178,255,1),
      0 0 10px rgba(0,178,255,1),
      0 0 15px rgba(0,178,255,1),
      0 0 20px rgba(38,104,127,1),
      0 0 25px rgba(38,104,127,1),
      0 0 30px rgba(38,104,127,1),
      0 0 35px rgba(38,104,127,1),
      0 0 40px rgba(38,104,127,1),
      0 0 45px rgba(38,104,127,1);
}
</style>